/* Google Basic Consent Mode: no Google requests until explicit Shopify consent.
 * GTM-PSDMRQV already owns G-YTH7DKL318 and also contains marketing tags.
 * Both categories are therefore required; do not add a second GA loader.
 */
(() => {
  'use strict';
  if (window.reischlGoogleConsentInstalled) return;
  window.reischlGoogleConsentInstalled = true;
  const measurementId = 'G-YTH7DKL318';
  const containerId = 'GTM-PSDMRQV';
  const root = document.documentElement;
  let started = false;
  let reloading = false;
  let attempts = 0;
  window.dataLayer = window.dataLayer || [];
  function consentCommand() { window.dataLayer.push(arguments); }
  // These commands stay local while the remote container is blocked.
  consentCommand('consent', 'default', {
    analytics_storage: 'denied', ad_storage: 'denied',
    ad_user_data: 'denied', ad_personalization: 'denied',
    functionality_storage: 'denied', personalization_storage: 'denied',
    security_storage: 'granted'
  });
  window['ga-disable-' + measurementId] = true;
  root.dataset.reischlGoogleConsent = 'blocked';

  function permitted() {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      const consent = privacy?.currentVisitorConsent();
      return consent?.analytics === 'yes' && consent?.marketing === 'yes' &&
        consent?.sale_of_data !== 'no' &&
        privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (_) { return false; }
  }

  function clearGoogleCookies() {
    // Only Google cookies owned by these integrations; never change Shopify cookies.
    const domains = location.hostname.split('.');
    const paths = new Set(['/']);
    const parts = location.pathname.split('/');
    while (parts.length > 1) { paths.add(parts.join('/') || '/'); parts.pop(); }
    for (const pair of document.cookie.split(';')) {
      const name = pair.split('=')[0].trim();
      if (!/^(_ga(?:_|$)|_gid$|_gat(?:_|$)|_gcl_)/.test(name)) continue;
      for (const path of paths) {
        const expired = name + '=; Max-Age=0; Path=' + path + '; SameSite=Lax';
        document.cookie = expired;
        for (let i = 0; i < domains.length - 1; i++) {
          document.cookie = expired + '; Domain=.' + domains.slice(i).join('.');
        }
      }
    }
  }

  function syncConsent() {
    if (reloading) return;
    if (!permitted()) {
      window['ga-disable-' + measurementId] = true;
      root.dataset.reischlGoogleConsent = 'blocked';
      if (started) {
        // Unload the running container when consent is withdrawn. The next page
        // remains blocked; merely removing a script element would not stop its JS.
        reloading = true;
        clearGoogleCookies();
        location.reload();
      }
      return;
    }
    if (started) return;
    started = true;
    window['ga-disable-' + measurementId] = false;
    const preferences = window.Shopify.customerPrivacy.currentVisitorConsent().preferences === 'yes';
    consentCommand('consent', 'update', {
      analytics_storage: 'granted', ad_storage: 'granted',
      ad_user_data: 'granted', ad_personalization: 'granted',
      functionality_storage: preferences ? 'granted' : 'denied',
      personalization_storage: preferences ? 'granted' : 'denied'
    });
    window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
    // The existing container uses this custom trigger, not an All Pages trigger.
    window.dataLayer.push({ event: 'ga4_page_view' });
    const script = document.createElement('script');
    script.async = true;
    script.id = 'reischl-google-tag-manager';
    script.src = 'https://www.googletagmanager.com/gtm.js?id=' + containerId;
    script.addEventListener('load', () => { root.dataset.reischlGoogleConsent = 'loaded'; });
    script.addEventListener('error', () => { root.dataset.reischlGoogleConsent = 'load-failed'; });
    root.dataset.reischlGoogleConsent = 'loading';
    document.head.append(script);
  }

  function initialize() {
    if (window.Shopify?.customerPrivacy) { syncConsent(); return; }
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (!error) syncConsent();
      });
    } else if (++attempts < 20) { setTimeout(initialize, 500); }
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  window.addEventListener('pageshow', syncConsent);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) syncConsent(); });
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-reischl-cookie-settings]');
    if (!button) return;
    const status = document.getElementById('reischl-cookie-settings-status');
    if (status) status.textContent = '';
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('Cookie banner unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      if (status) status.textContent = 'Die Cookie-Einstellungen sind momentan nicht verfügbar. Bitte lade die Seite erneut. Google bleibt ohne Zustimmung gesperrt.';
    }
  });
  initialize();
})();
